module.exports = __webpack_public_path__ + "img/sec2_2.b0e10e3c.png";